import React from "react";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import BrandFooter from "./BrandFooter";

export default function Layout({ children }) {
  const [collapsed, setCollapsed] = React.useState(false);

  React.useEffect(() => {
    document.title = "QualiGate";
  }, []);

  return (
    <div className="app-shell">
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      <div className="content">
        <Topbar />
        <main className="main premium-fade-in">{children}</main>
        <BrandFooter className="shell-footer" />
      </div>
    </div>
  );
}
